import { toast as sonnerToast } from 'sonner';
import { haptic } from './haptics';

export const toast = Object.assign(
	(...args: Parameters<typeof sonnerToast>) => sonnerToast(...args),
	{
		success: (...args: Parameters<typeof sonnerToast.success>) => {
			haptic('success');
			return sonnerToast.success(...args);
		},
		error: (...args: Parameters<typeof sonnerToast.error>) => {
			haptic('warning');
			return sonnerToast.error(...args);
		},
		warning: (...args: Parameters<typeof sonnerToast.warning>) => {
			haptic('warning');
			return sonnerToast.warning(...args);
		},
		info: sonnerToast.info,
		loading: sonnerToast.loading,
		promise: sonnerToast.promise,
		dismiss: sonnerToast.dismiss,
		message: sonnerToast.message,
		custom: sonnerToast.custom,
	},
);
